import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { signin } from '../../redux/actions/userActions'
import { lastLoginAt, profileID } from '../../utils/mockData'
import PageNotFound from '../PageNotFound'
import permissions from './permissions'

export default function requireAuth(Component, param = {}) {
  class AuthenticatedComponent extends React.Component {

    state = {
      render: true
    }

    componentWillMount() {
      this.checkAuth()
      this.checkModuleAccess()
      this.checkSubModuleAccess()
      this.checkAccess()
      this.checkNewUser()
    }

    checkModuleAccess() {

      if (this.props.settings && this.props.settings.modules && param.module) {
        //if current module is not in list of allowed modules, do not render
        if (!this.props.settings.modules.includes(param.module)) {
          this.setState({ render: false })
        }
      }
    }

    async checkSubModuleAccess(){
      if (this.props.settings && this.props.settings.sub_modules && param.sub_module){
        //if current sub module is not in list of allowed sub modules, do not render
        if(!this.props.settings.sub_modules.map((subModule)=>{
          if(subModule.sub_module_name == 'training'){return subModule.categories}})[0].includes(param.sub_module)){
          this.setState({ render: false})
        }
      }
    }

    checkAuth() {
      if (!this.props.user) {
        const location = {
          pathname: '/',
          state: { from: { pathname: `${this.props.location.pathname}${this.props.location.search}` } }
        }

        localStorage.getItem('pos-session')
          ? this.props.signin(JSON.parse(localStorage.getItem('pos-session')))
          : this.props.history.push(location)
      }
    }

    checkAccess() {
      const groups = this.props.user &&
        this.props.user['cognito:groups'] &&
        this.props.user['cognito:groups']

      if (process.env.REACT_APP_ENV === 'demo' ||
        process.env.REACT_APP_ENV === 'dev' ||
        process.env.REACT_APP_ENV === 'prod') {
        if (param && param.routeName) {
          if (groups) {
            let letView = false;
            for (let groupIndex = 0; groupIndex < groups.length; groupIndex++) {
              letView = !permissions[groups[groupIndex]].restricted.includes(param.routeName);
              if (letView) {
                break;
              }
            }
            this.setState({
              render: letView
            })
          } else {
            this.setState({ render: false })
          }
        }
      }
    }

    checkNewUser() {
      const hasLoggedIn = this.props.user &&
        this.props.user['custom:hasLoggedIn'] &&
        this.props.user['custom:hasLoggedIn'].toLowerCase()

      if (hasLoggedIn && hasLoggedIn === 'false' && this.props.location.pathname !== '/app/get-started') {
        this.props.history.push('/app/get-started')
      }
    }

    render() {

      return this.props.user ?
        ((lastLoginAt && profileID) || param.excludeProfileValidation) &&
          this.state.render ?
          <Component
            {...param}
            // description={param ? param.description : null}
            // name={param ? param.name : null}
            // frameworkId={param ? param.frameworkId : null}
            // parse={param ? param.parse : null}
            // compliance={param ? param.compliance : null} 
            />
          : <PageNotFound />
        : null
    }
  }

  function mapStateToProps(state) {
    return {
      user: state.auth.user,
      settings: state.auth.settings
    }
  }

  return withRouter(connect(mapStateToProps, { signin })(AuthenticatedComponent))
}



// WEBPACK FOOTER //
// ./src/components/hoc/requireAuth.js